import { Card, CardProps } from "@chakra-ui/card";
import React from "react";
import { useDrag } from "react-dnd";
import { Bank, Preset } from "../utils/types";
import { DraggableType } from "./DropZone";
import { Title } from "./Title";
import { BsSliders as PresetIcon } from 'react-icons/bs';

interface Props extends CardProps {
    preset: Preset | undefined;
    index: number;
    hideIndices: boolean;
    handleRename: (entity: Bank | Preset, newName: string) => void;
}

export const PresetCard = ({ preset, index, hideIndices, handleRename, children, ...props }: Props) => {
    const cardProps = props ?? {};
    // useDrag
    const [{ opacity }, drag] = useDrag({
        item: preset,
        type: DraggableType.PRESET,
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        }),
        previewOptions: {
            captureDraggingState: true,
        }
    });

    return (
        <Card
            display='grid'
            gridTemplateColumns='1fr 10fr'
            alignItems='center'
            boxShadow='none'
            border='1px solid #ccc'
            padding='0.5rem 1rem'
            ref={drag}
            touchaction='none'
            cursor='grab'
            opacity={opacity}
            transition='all 0.2s'
            _hover={{ backgroundColor: '#efefef' }}
            {...cardProps}
        >
            <PresetIcon />   
            <Title
                entity={preset!}
                index={index}
                hideIndices={hideIndices}
                handleRename={handleRename} />
            {children}
        </Card>
    );
}